<span class="badge motivo-perda-venda-situacao-badge"
    [class.badge-success]="config?.isAtivo"
    [class.badge-danger]="config?.isInativo"
    [style.fontSize]="fontSize">
    {{situacao | motivoPerdaVendaSituacao }}
</span>